import React from 'react';
import Spinner from 'react-bootstrap/Spinner'

export default function Loading(props)
{
    if (props.status==="?")
    {
        return (
            <div className="pr1">
                <Spinner animation="grow" variant="primary" />
            </div>
          )
    } else if (props.status) {
        return(
                <div className="pr1 error">
                    <p>{props.status}</p>
                </div>
            )
    } else {
        return (<></>);
    }
}